<template>
  <img
  v-if="lv > 0"
  :src="lv === 7 ?
  `${BaseUrl}assets/label_diamond.png` :
  (lv === 6 ?
  `${BaseUrl}assets/label_platinum.png` :
  `${BaseUrl}assets/label_gold.png`)"
  :srcset="lv === 7 ?
  `${BaseUrl}assets/label_diamond@2x.png` :
  (lv === 6 ?
  `${BaseUrl}assets/label_platinum@2x.png` :
  `${BaseUrl}assets/label_gold@2x.png`)"
  :width="size"
  class="lv">
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Level',
  computed: {
    ...mapGetters(['BaseUrl'])
  },
  props: {
    lv: {
      type: Number,
      default: 0
    },
    size: {
      type: Number,
      default: 30
    }
  }
}
</script>
